import { Box, styled } from '@mui/material';
import { useIsMobile } from '@side/pantry';
import type { Dictionary } from 'lodash';
import type { TeamSearchResult } from '../../types';
import { EmptyListState } from '../EmptyListState';
import { PartnerCardList } from '../PartnerCardList';

const MobileListContainer = styled(Box, {
  shouldForwardProp: (propName) => propName !== 'isOpen',
})<{
  isOpen: boolean;
}>(({ isOpen }) => ({
  position: 'absolute',
  width: '100%',
  top: isOpen ? 0 : '100%',
  backgroundColor: 'white',
  overflowY: 'auto',
}));

interface Props {
  showList: boolean;
  isEmpty: boolean;
  loading: boolean;
  partnerGroups: Dictionary<TeamSearchResult[]>;
}
export const MobilePartnerCardList = ({
  showList,
  isEmpty,
  ...rest
}: Props) => {
  const isMobile = useIsMobile('md');

  if (!isMobile) {
    return null;
  }

  if (isEmpty) {
    return (
      <MobileListContainer isOpen sx={{ height: showList ? '100%' : 'unset' }}>
        <EmptyListState
          sx={{
            boxShadow: 'inset 0px 4px 8px rgba(0, 0, 0, 0.10)',
            height: '100%',
          }}
        />
      </MobileListContainer>
    );
  }

  return (
    <MobileListContainer
      isOpen={showList}
      sx={{
        height: '100%',
        borderTop: (theme) => `1px solid ${theme.palette.grey[300]}`,
      }}
    >
      <PartnerCardList {...rest} />
    </MobileListContainer>
  );
};
